import type { DocumentLineageResponse, SpaceHubResponse } from "@/api";
import { ChatDocumentsPanel } from "./ChatDocumentsPanel";
import type { OpenDocument } from "./documents/documentInfo";
import { SourceFilePanel } from "./SourceFilePanel";
import type { ShownSourceFile } from "./usePerChatState";

/** What opens beside the chat, one at a time: one of its documents, or a file an answer used (MHS-1040). */
export function ChatPreviewPanel({
  documents,
  doc,
  onOpenDoc,
  file,
  space,
}: Readonly<{
  documents: DocumentLineageResponse[];
  doc: OpenDocument | null;
  onOpenDoc: (doc: OpenDocument | null) => void;
  file: ShownSourceFile;
  /** The chat's space, when I may see it: its editors share the chat's documents into it. */
  space?: SpaceHubResponse;
}>) {
  const { shown } = file;
  return (
    <>
      {doc && documents.length > 0 && (
        <ChatDocumentsPanel
          key={`${doc.lineageUuid}|${doc.attachmentUuid ?? "latest"}`}
          documents={documents}
          open={doc}
          onOpen={onOpenDoc}
          onClose={() => onOpenDoc(null)}
          shareTo={space?.canEdit ? { uuid: space.uuid, name: space.name } : undefined}
        />
      )}
      {shown && <SourceFilePanel key={shown.uuid} file={shown} onOpen={file.open} onClose={() => file.open(null)} />}
    </>
  );
}
